import './configTemplateSingle.sass'
import ConfigPdfTemplateConfig from './ConfigPdfTemplateConfig'
import ConfigPdfWhitePaper from './ConfigPdfWhitePaper'
import { useCallback, useEffect, useState } from 'react'
import { PdfConfigTemplateSingleTy } from './types'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { useParams } from 'react-router'
import LoaderDecider from '../../../../../../baseComponents/LoaderDecider'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'

interface ConfigPdfTemplateSingleProps extends ComponentWithPermissions{ }
const ConfigPdfTemplateSingle: React.FC<ConfigPdfTemplateSingleProps> = ({ userPermissions }) => {
    const { ...logic } = useConfigPdfTemplateSingleLogic()
    const specialTypes: TwinDictionary = {
        ticket: 'ticket',
        ticketRefund: 'ticket',
        voucher: 'ticket',
        giftTicket: 'ticket',
        cashRegister: 'ticket'
    }
    const configType = logic?.config?.type
    const myType = configType && specialTypes[configType] ? specialTypes[configType] : 'a4'
    return (
        <LoaderDecider loading={logic.config === null}>
            <div className='flex flex-auto h-1 pdf-template-single'>
                {logic.config ? <ConfigPdfTemplateConfig {...logic as any} userPermissions={userPermissions} /> : null}
                {logic.config
                    ? <ConfigPdfWhitePaper {...{ type: myType, config: logic.config }} />
                    : null}
            </div>
        </LoaderDecider>
    )
}

const defaultValues: PdfConfigTemplateSingleTy = {
    id: 0,
    document: {
        cssConfig: {}
    },
    pages: []
}
const useConfigPdfTemplateSingleLogic = () => {
    const {id} = useParams()
    const [config, setConfig] = useState<PdfConfigTemplateSingleTy | null>(null)
    const getData = useCallback(async () => {
        const data = await twinFetchPostJSON('/api/app/config/pdfTemplate/getPdfTemplateInstance', {
            id
        })
        if (data) {
            const code = data.code ? JSON.parse(data.code) : defaultValues
            setConfig({ ...code, id: data.id, type: data.type })
        }
    }, [id, setConfig])

    useEffect(() => {
        getData()
    }, [getData])


    return { config, setConfig }
}

export default ConfigPdfTemplateSingle